module.exports = __webpack_public_path__ + "img/squared-stories.a20d983b.png";